import { FunctionComponent } from 'react';
import { IconCheckmark } from '@tocktix/pantry';
import { PartyStatusIconData } from 'components/settings/business-defined-states/partyStatusIcons';
import { StateDescription } from 'types/service';
import { dashboard } from 'types';
import { useFeatureFlag } from '@tock/shared/utils/featureFlagContext';
import PartyStatusIcon from 'components/settings/business-defined-states/PartyStatusIcon';
import StatusIcon from 'components/service/StatusIcon';

interface Props {
  className?: string;
  isSelected?: boolean;
  option: StateDescription;
}

function toPartyStatusIconData(option: StateDescription): PartyStatusIconData {
  return {
    className: option.className,
    strokeColorClassName: option.strokeColorClassName,
    border: option.border ?? '',
    icon: option.icon ?? '',
    label: option.stateName ?? undefined,
    primaryState: option.primaryState as dashboard.PartyState,
    key: `${option.primaryState}-${option.secondaryValue}`,
  };
}

const SecondaryStateItem: FunctionComponent<React.PropsWithChildren<Props>> = ({
  className,
  isSelected,
  option,
}) => {
  const isPartyStatusRefresh = useFeatureFlag('PARTY_STATUS_REFRESH');

  const classNames = ['SecondaryStateItem'];
  if (className) {
    classNames.push(className);
  }

  if (isPartyStatusRefresh) {
    return (
      <div className={classNames.join(' ')}>
        <span className="SecondaryStateItem-icon">
          <PartyStatusIcon state={toPartyStatusIconData(option)} />
        </span>
        <span className="SecondaryStateItem-text">{option.stateName}</span>
        {isSelected && (
          <IconCheckmark className="SecondaryStateItem-check" aria-hidden={true} size={200} />
        )}
      </div>
    );
  }

  return (
    <div className={classNames.join(' ')}>
      <StatusIcon classNames="SecondaryStateItem-icon" stateDescription={option} />
      <span className="SecondaryStateItem-text">{option.stateName}</span>
    </div>
  );
};
export default SecondaryStateItem;
